import { TableFile } from "../types/table";

export const tableFileToData: (table: TableFile) => string[][] = (table) => {
  return [...table.header, ...table.rows];
};

export const coerceNumbers = (data?: any[][]): any[][] => {
  return (
    data?.map((row) =>
      row.map((value) => {
        const num = Number(value);
        return isNaN(num) ? value : num;
      })
    ) ?? []
  );
};

export const coerceTableFileNumbers: (table: TableFile) => TableFile = (
  table
) => {
  return { ...table, rows: coerceNumbers(table.rows) };
};
